import { isObject } from 'lodash';
import { planTypes } from '@/common/constants';
import { $config, $context } from '@/global-install';
import { persistCartConstant } from '@/views/config/shopping-cart/persist/persist-cart';
import { pageConfig } from '@/common/service/page-config';
import store from '@/store/index';

const isSelectedPlanDependOnTargetPlan = (type, draftSelectedPlans) => {
  return draftSelectedPlans
    .filter((item) => item?.type !== type)
    .some((item) => item?.dependBasePlanTypeList?.includes(type));
};

const isContainsStandalone = (type, draftSelectedPlans) => {
  return draftSelectedPlans
    .filter((item) => item?.type !== type)
    .some((item) => item?.dependBasePlanTypeList?.length === 0);
};

const getDraftPlans = (planMapFlat, draftPlanFilterKeys) => {
  const list = [];
  const planTypeMap = draftPlanFilterKeys.reduce((acc, cur) => {
    return {
      ...acc,
      [cur]: true,
    };
  }, {});
  const additionalPlanType = [planTypes.ADDITIONAL_HOST, planTypes.ADDITIONAL_CO_EDITOR];

  for (const item of planMapFlat) {
    const planType = planTypes[item.type];
    const basePlanType = planTypes[item.baseType];
    const isAdditionalType = additionalPlanType.includes(item.type);

    const shouldAddItem =
      planTypeMap[planType] &&
      (!isAdditionalType || (draftPlanFilterKeys.includes(basePlanType)));

    if (shouldAddItem) {
      list.push(item);
      planTypeMap[planType] = false;
    }
  }

  return list;
};

// product can remove common methods
export const isProductCanRemove = (currentPlan) => {
  const { planMapFlat, draftPlanFilterKeys } = store.getters;
  // Special case, zoom event services depend on webinar single use.
  // but this plan can't remove by itself, When you remove webinar single use, this plan will be removed automatically
  const draftPlanFilterKeysWithoutEventServices = draftPlanFilterKeys.filter(
    (planType) => planType !== planTypes.zoom_event_services,
  );
  const draftSelectedPlans = getDraftPlans(planMapFlat, draftPlanFilterKeysWithoutEventServices);

  if (!isObject(currentPlan) || !Array.isArray(draftSelectedPlans)) {
    return false;
  }

  if (draftSelectedPlans.length < 2) {
    return false;
  }

  // Special cases, for zoom_pro_plus, zoom phone & zoom pro plus use the same config card
  if ([planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS, planTypes.ZOOM_ONE_BUNDLE].includes(currentPlan?.type)) {
    const leftPlans = draftSelectedPlans.filter(
      (plan) =>
        ![planTypes.ZOOM_PHONE, planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS, planTypes.ZONE_EDU_PLUS].includes(
          plan.type,
        ),
    );
    if (leftPlans.length < 1) {
      return false;
    }
  }

  const isCurrentPlanDepended = isSelectedPlanDependOnTargetPlan(currentPlan.type, draftSelectedPlans);

  // addon: if other addon depend on this addon, we can't remove
  if (currentPlan?.dependBasePlanTypeList?.length && isCurrentPlanDepended) {
    return false;
  }

  // basePlan: addon depend this product || no other standalone product
  // current base plan can't remove
  const isStandaloneExist = isContainsStandalone(currentPlan.type, draftSelectedPlans);
  if (isCurrentPlanDepended || !isStandaloneExist) {
    return false;
  }

  // standalone or base plan without dependency
  return true;
};

export const isFromShoppingCart = () => {
  const isSupportedFlow = $context.is.buyNow || $context.is.buyTrial || $context.is.basic2pro;

  return (
    persistCartConstant?.enablePersistShoppingBag &&
    $config('persist_cart') === 'true' &&
    isSupportedFlow &&
    !window.campaignFlags?.disableRemovePlanWithPersistCart
  );
};

export const isProductExcludedInShoppingCart = (selectedPlans) => {
  return isFromShoppingCart() && !selectedPlans.some((plan) => plan?.type === pageConfig?.editConfig?.planType);
};

export const checkBasePlanCanRemove = (currentPlan) => {
  const { planMapFlat, draftPlanFilterKeys } = store.getters;
  // Special case, zoom event services depend on webinar single use.
  // but this plan can't remove by itself, When you remove webinar single use, this plan will be removed automatically
  const draftPlanFilterKeysWithoutEventServices = draftPlanFilterKeys.filter(
    (planType) => planType !== planTypes.zoom_event_services,
  );
  const draftSelectedPlans = getDraftPlans(planMapFlat, draftPlanFilterKeysWithoutEventServices);
  const isCurrentPlanDepended = isSelectedPlanDependOnTargetPlan(currentPlan.type, draftSelectedPlans);
  // basePlan: addon depend this product || no other standalone product
  // current base plan can't remove
  const isStandaloneExist = isContainsStandalone(currentPlan.type, draftSelectedPlans);
  if (isCurrentPlanDepended || !isStandaloneExist) {
    return false;
  }
  return true;
}
